export const Education = (
  <div>
    <div>
      <p className="cc-2">// Certificates</p>
      <p>
        MINOR - <small>Language and Culture - Arabic</small>
      </p>
      <p>Date: 12 JUL 2021</p>
    </div>
    <br />
    <div>
      <p className="cc-2">// Hogeschool Arnhem Nijmegen</p>
      <p>
        HBO ICT - <small>Infrastructure & Security Management</small>
      </p>
      <p>Period: 2017 - 2023</p>
    </div>
    <br />
    <div>
      <p className="cc-2">// Horizon College Purmerend</p>
      <p>
        MBO N4 - <small>ICT Application Development</small>
      </p>
      <p>Period: 2013 - 2016</p>
    </div>
  </div>
);
export default Education;
